import { NgClass } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

type RGBA = `rgba(${number}, ${number}, ${number}, ${number})`;

@Component({
  selector: 'app-portal-button',
  imports: [NgClass],
  templateUrl: './portal-button.component.html',
  styleUrl: './portal-button.component.css',
})
export class PortalButtonComponent {
  color = input<'orange' | 'blue' | 'red'>('orange');
  disabled = input(false);
  clicked = output();

  gradient = computed<{ stop1: RGBA; stop2: RGBA }>(() => {
    switch (this.color()) {
      case 'blue':
        return {
          stop1: `rgba(234, 242, 254, 1)`,
          stop2: `rgba(101, 156, 248, 1)`,
        };
      case 'orange':
        return {
          stop1: `rgba(254, 213, 11, 1)`,
          stop2: `rgba(240, 116, 3, 1)`,
        };
      case 'red':
        return {
          stop1: `rgba(243, 173, 150, 1)`,
          stop2: `rgba(234, 65, 51, 1)`,
        };

      default:
        throw new Error(`Unsupported color: ${this.color()}`);
    }
  });
}
